import { getTokenUserId } from '@shared/lib/jwt';
import { authStorage } from './auth-storage';

/**
 * Токен в хранилище принадлежит тому же пользователю, чей профиль загружен в этой вкладке.
 * Хранилище общее для вкладок: вход другим аккаунтом в соседней вкладке подменяет токен,
 * а профиль, баланс и списки здесь остаются от прежнего аккаунта.
 * Если токена или id в нём нет, сравнивать не с чем — считаем сессию согласованной
 * (выход из аккаунта обрабатывается отдельно).
 */
export const isSessionBoundToUser = (userId: string | null | undefined): boolean => {
  if (userId == null) {
    return true;
  }

  const token = authStorage.getAccessToken();
  const tokenUserId = token ? getTokenUserId(token) : null;

  return tokenUserId == null || tokenUserId === String(userId);
};
